<template>
    <div></div>
</template>

<script>
    import {canvasHelper} from "../../mixins/canvasHelper";

    export default {
        name: 'CanvasRadar',
        mixins: [canvasHelper],
        computed: {
            perspective() {
                return this.config.radar
            },
            blobs() {
                return this.$store.getters['blobs/getRadarBlobs'](this.radar.id)
            },
            quadrantLabels() {
                return [0, 1, 2, 3]
            }
        }
    }
</script>
